import { useTranslation } from 'react-i18next';
import { extensionSVG } from '../../lib/allCustomSVGs';
import MainSquareButton from '../../ui/buttons/MainSquareButton';
import CustomSVGs from '../../ui/customSVGs/CustomSVGs';
import chromeExtensionsImg from '../../assets/chrome-extensions.png';
import '../../styles/pages/aiOptimizations/aiOptimizationsChromeExtensionCard.scss';
import { ADUP_AI_OPTIMIZER_CHROME_EXTENSION_URL } from '../../lib/constants/central-api';

type Props = {
  toggleChromeExtensionPopupModal: () => void;
};

const AIOptimizationsChromeExtensionCard = ({
  toggleChromeExtensionPopupModal,
}: Props) => {
  const { t } = useTranslation();

  const handleInstallExtension = () => {
    const width = 800;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    window.open(
      ADUP_AI_OPTIMIZER_CHROME_EXTENSION_URL,
      'chromeWebStorePopup',
      `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes`
    );
  };

  return (
    <div className='aiOptimizationsChromeExtensionCard'>
      <div className='aiOptimizationsChromeExtensionCard__title'>
        <CustomSVGs svg={extensionSVG} />
        <h3>{t('ChromeExtensionTitle')}</h3>
      </div>
      <div className='aiOptimizationsChromeExtensionCard__message'>
        {t('ChromeExtensionDescription')}
      </div>

      {/* Install Section */}
      <div className='aiOptimizationsChromeExtensionCard__download'>
        <div className='aiOptimizationsChromeExtensionCard__download--titles'>
          <p>{t('ChromeExtensionInstallInstructions1')}</p>
          <ul>
            <li>{t('ChromeExtensionInstallInstructions2')}</li>
          </ul>
        </div>
        <div
          className='normalForm__container1--left'
          style={{
            marginTop: '-1rem',
            marginBottom: '1.8rem',
            maxWidth: '32.3rem',
          }}
        >
          <div className='aiOptimizationsChromeExtensionCard__install-button login__right--other'>
            <div className='login__right--bottom-button'>
              <MainSquareButton
                value={t('ChromeExtensionInstallButton')}
                type='button'
                image={chromeExtensionsImg}
                contentLayout='imageTextSeparate'
                disabled={false}
                onClick={handleInstallExtension}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Installation Instructions */}
      <div className='aiOptimizationsChromeExtensionCard__instructions'>
        <div className='aiOptimizationsChromeExtensionCard__instructions--steps'>
          <p>{t('ChromeExtensionInstructionsDescription')}</p>
          <ul>
            <li>{t('ChromeExtensionStep1Description')}</li>
            <li>{t('ChromeExtensionStep2Description')}</li>
          </ul>
        </div>
      </div>

      <div className='aiOptimizationsChromeExtensionCard__message'>
        {t('ChromeExtensionConclusion')}
      </div>
    </div>
  );
};

export default AIOptimizationsChromeExtensionCard;
